// src/Components/Portfolio.js
import React, { Component } from "react";
import Zmage from "react-zmage";
import Fade from "react-reveal";

let id = 0;

class Portfolio extends Component {
  render() {
    if (!this.props.data) return null;

    const projects = this.props.data.projects.map((project) => {
      const projectImage = "images/portfolio/" + project.image;

      return (
        <div key={id++} className="column">
          <div className="item-wrap">
            <Zmage alt={project.title} src={projectImage} />
            <div>
              <div className="project-title">{project.title}</div>
              <div className="project-subtitle">{project.category}</div>
              <div style={{ marginTop: "8px" }}>
                <a href={project.url} target="_blank" rel="noopener noreferrer">
                  View project
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    });

    return (
      <section id="portfolio">
        <Fade bottom duration={1000} distance="24px">
          <div className="row">
            <h1>Check Out Some of My Work.</h1>
            <div id="portfolio-wrapper" className="portfolio-grid">
              {projects}
            </div>
          </div>
        </Fade>
      </section>
    );
  }
}

export default Portfolio;
